<div class="container p-4" >
    <div class="card p-5">

        <div class='container'>

            <h3><i style="color:green;" class="fa fa-check-circle"></i> Thank you for placing your order</h3>
            <p>Your order was placed successfully. please save the following order details for future reference.</p>
            <h5 class="mt-3">Order# {{order_id}}</h5>

            <table width="80%" class=" table-sm table-striped">

                <tbody>


                <tr>
                    <th>ID</th>
                    <th>Type</th>
                    <th>Method</th>
                    <th>Transaction ID ()</th>
                    <th>Time</th>
                </tr>


                <tr>
                    <td>{{transaction_id}}</td>
                    <td>{{txn_type}}</td>
                    <td>{{method}}</td>
                    <td>{{txn_id}}</td>
                    <td>{{created_at}}</td>
                </tr>

                </tbody>
            </table>
        </div>


    </div>


</div>

